import React, { useContext, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { UserProfile } from './contexts/UserContext';
import { ServiceProfile } from './contexts/ServiceContext';
import { SystemProfile } from './contexts/SystemContext';
import Erro from './utilities/Erro';


import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import { CriarVistoria } from './pages/Vistorias/CriarVistoria';
import BuscarVistorias from './pages/Vistorias/BuscarVistorias';
import HistoricoDeVistorias from './pages/Vistorias/HistoricoDeVistorias';
import VistoriasEmAberto from './pages/Vistorias/VistoriasEmAberto';
import ListarEmpresas from './pages/Empresas/ListarEmpresas';
import AdicionarEmpresa from './pages/Empresas/AdicionarEmpresa';
import ListarUsuarios from './pages/Usuarios/ListarUsuarios';
import AdicionarUsuario from './pages/Usuarios/AdicionarUsuario';
import ListarAdministradores from './pages/AdminUser/ListarAdministradores';
import AdicionarAdmin from './pages/AdminUser/AdicionarAdmin';
import VistoriaDetalhe from './pages/Vistorias/VistoriaDetalhe';
import EditarEmpresa from './pages/Empresas/EditarEmpresa';
import AdicionarNr from './pages/Nr/AdicionarNr';
import ListarNr from './pages/Nr/ListarNr';

function App() {
  const [userData, setUserData] = useState([])
  const [systemData, setSystemData] = useState([])
  const [serviceData, setServiceData] = useState([])

  console.log('System: '+JSON.stringify(systemData))

  return (
    
      <SystemProfile.Provider value={[systemData, setSystemData]}>
        <UserProfile.Provider value={[userData, setUserData]}>
          <ServiceProfile.Provider value={[serviceData, setServiceData]}>
            {systemData.erro ? <div style={styles.erro}><Erro /></div> : <></> }
            <Routes>
              <Route path="/" element={<Navigate to="/login" />} />
              <Route path="/login" element={systemData.logged ?  <Dashboard /> : <Login />} />
              <Route path="/dashboard" element={systemData.logged ? <Dashboard /> : <Login />} />
              <Route path="/criar-inspecao" element={systemData.logged ? <CriarVistoria /> : <Login />} />
              <Route path="/inspecoes-em-aberto" element={systemData.logged ? <VistoriasEmAberto /> : <Login />} />
              <Route path="/buscar-inspecao" element={systemData.logged ? <BuscarVistorias /> : <Login />} />
              <Route path="/historico-de-inspecoes" element={systemData.logged ? <HistoricoDeVistorias /> : <Login />} />
              <Route path="/vistoria-detalhe" element={systemData.logged ? <VistoriaDetalhe /> : <Login />} />
              <Route path="/listar-usuarios" element={systemData.logged ? <ListarUsuarios /> : <Login />} />
              <Route path="/adicionar-usuarios" element={systemData.logged ? <AdicionarUsuario /> : <Login />} />
              <Route path="/listar-empresas" element={systemData.logged ? <ListarEmpresas /> : <Login />} />
              <Route path="/adicionar-empresas" element={systemData.logged ? <AdicionarEmpresa /> : <Login />} />
              <Route path="/editar-empresa" element={systemData.logged ? <EditarEmpresa /> : <Login />} />
              <Route path="/listar-administradores" element={systemData.logged ? <ListarAdministradores /> : <Login />} />
              <Route path="/criar-admin" element={systemData.logged ? <AdicionarAdmin /> : <Login />} />
              <Route path="/listar-nr" element={systemData.logged ? <ListarNr /> : <Login />} />
              <Route path="/adicionar-nr" element={systemData.logged ? <AdicionarNr /> : <Login />} />
            </Routes>
          </ServiceProfile.Provider>
        </UserProfile.Provider>
      </SystemProfile.Provider>
    
  )
}

export default App;

const styles = {
  erro: {
    position: 'absolute',
    zIndex: 99999,
    width: 500,
    left: 310,
    top: 70
  }
}